var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80566 12.9026C2.80566 15.5548 3.85923 18.0983 5.7346 19.9737C7.60996 21.849 10.1535 22.9026 12.8057 22.9026C15.4578 22.9026 18.0014 21.849 19.8767 19.9737C21.7521 18.0983 22.8057 15.5548 22.8057 12.9026C22.8057 10.2504 21.7521 7.70688 19.8767 5.83152C18.0014 3.95616 15.4578 2.90259 12.8057 2.90259C10.1535 2.90259 7.60996 3.95616 5.7346 5.83152C3.85923 7.70688 2.80566 10.2504 2.80566 12.9026Z",
    fill: "#E0FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80566 12.9026C2.80566 15.5548 3.85923 18.0983 5.7346 19.9737C7.60996 21.849 10.1535 22.9026 12.8057 22.9026C15.4578 22.9026 18.0014 21.849 19.8767 19.9737C21.7521 18.0983 22.8057 15.5548 22.8057 12.9026C22.8057 10.2504 21.7521 7.70688 19.8767 5.83152C18.0014 3.95616 15.4578 2.90259 12.8057 2.90259C10.1535 2.90259 7.60996 3.95616 5.7346 5.83152C3.85923 7.70688 2.80566 10.2504 2.80566 12.9026Z",
    stroke: "#287887",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8052 7.40259L14.5832 10.4556L18.0362 11.2026L15.6822 13.8376L16.0382 17.3526L12.8052 15.9276L9.57222 17.3526L9.92822 13.8376L7.57422 11.2026L11.0272 10.4556L12.8052 7.40259Z",
    fill: "#E0FAFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8052 7.40259L14.5832 10.4556L18.0362 11.2026L15.6822 13.8376L16.0382 17.3526L12.8052 15.9276L9.57222 17.3526L9.92822 13.8376L7.57422 11.2026L11.0272 10.4556L12.8052 7.40259Z",
    stroke: "#287887",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star_icon.cd219e7f51f2b8c7be8953cb80b2845f.svg";
export { ForwardRef as ReactComponent };